import {
  Box,
  Divider,
  Drawer,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import {  HiOutlinePhone } from "react-icons/hi2";
import { MdOutlineBusiness, MdOutlineCampaign } from "react-icons/md";

function DetailRow({ label, value, icon }) {
  if (value == null || value === "") return null;
  return (
    <>
      <Box sx={{ py: 1.5 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.75 }}>
          {icon}
          <Typography
            sx={{ color: "#666", fontWeight: 500, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.04em" }}
          >
            {label}
          </Typography>
        </Box>
        <Typography sx={{ fontWeight: 600, fontSize: "14px", color: "#1a1a1a", whiteSpace: "pre-wrap" }}>
          {value}
        </Typography>
      </Box>
      <Divider sx={{ borderColor: "#f0f0f0" }} />
    </>
  );
}

const InquiryDetailsDrawer = ({ open, inquiry, onClose }) => {
  if (!inquiry) return null;

  const initials = String(inquiry.fullName ?? "?")
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box
        sx={{
          width: { xs: "100vw", sm: 420, md: 480 },
          height: "100vh",
          bgcolor: "#fafafa",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            px: 3,
            py: 2.5,
            bgcolor: "#fff",
            borderBottom: "1px solid #eee",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", gap: 2, alignItems: "center", minWidth: 0 }}>
            <Box
              sx={{
                width: 52,
                height: 52,
                borderRadius: "14px",
                bgcolor: "#F5EEF7",
                color: "#7B408C",
                display: "grid",
                placeItems: "center",
                fontWeight: 800,
                fontSize: "16px",
                flexShrink: 0,
              }}
            >
              {initials}
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ fontWeight: 800, fontSize: "17px", lineHeight: 1.3 }}>
                {inquiry.fullName ?? "—"}
              </Typography>
              <Typography
                sx={{ fontSize: "12px", color: "#666", mt: 0.5, wordBreak: "break-all" }}
              >
                {inquiry.email ?? "—"}
              </Typography>
            </Box>
          </Box>
          <IconButton onClick={onClose} size="small" sx={{ bgcolor: "#f5f5f5" }}>
            <AiOutlineClose style={{ fontSize: "18px" }} />
          </IconButton>
        </Box>

        <Box sx={{ flex: 1, overflow: "auto", px: 3, py: 2 }}>
          <Box
            sx={{
              bgcolor: "#fff",
              borderRadius: "16px",
              border: "1px solid #eee",
              px: 2.5,
              overflow: "hidden",
            }}
          >
            <DetailRow
              label="Phone"
              value={inquiry.phoneNumber}
              icon={<HiOutlinePhone style={{ color: "#7B408C", fontSize: 16 }} />}
            />
            <DetailRow
              label="Organization"
              value={inquiry.organization}
              icon={<MdOutlineBusiness style={{ color: "#7B408C", fontSize: 16 }} />}
            />
            <DetailRow
              label="Investment range"
              value={inquiry.investmentRange}
              icon={<MdOutlineCampaign style={{ color: "#7B408C", fontSize: 16 }} />}
            />
            {/* <DetailRow
              label="How they heard about us"
              value={inquiry.heardAboutUs}
              icon={<HiOutlineMail style={{ color: "#7B408C", fontSize: 16 }} />}
            /> */}
            <DetailRow
              label="Reason for joining"
              value={inquiry.reasonForJoining}
              icon={null}
            />
            <DetailRow label="Submitted" value={formatDateTime(inquiry.createdAt)} icon={null} />
            <DetailRow label="Last updated" value={formatDateTime(inquiry.updatedAt)} icon={null} />
            <Box sx={{ py: 1.5 }}>
              <Typography sx={{ color: "#666", fontWeight: 500, fontSize: "11px", textTransform: "uppercase" }}>
                Inquiry ID
              </Typography>
              <Typography sx={{ fontWeight: 500, fontSize: "11px", mt: 0.75, color: "#888", wordBreak: "break-all" }}>
                {inquiry._id}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default InquiryDetailsDrawer;

function formatDateTime(dateString) {
  if (!dateString) return "—";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}
